import { useState } from 'react';

export const useBusinessPolicyViolationConditionSection = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpanded = () => setIsExpanded((current) => !current);

  return { isExpanded, toggleExpanded };
};
